module.exports = __webpack_public_path__ + "static/img/feature_bg.e0fb50a.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature/feature_bg.png
// module id = JkWD
// module chunks = 7